import moment from 'moment'

moment.locale('ja')

export default {
  methods: {
    /**
     * 日付をフォーマットする
     * @param date
     * @param format
     * @returns {any}
     */
    formatDate: (date, format = 'YYYY/MM/DD') => (
      date ? moment(date).format(format) : null
    ),

    /**
     * 数字をフォマットする
     * Intl.NumberFormat API
     * @param num
     * @returns number
     */
    formatNumber: (num) => (
      new Intl.NumberFormat('ja-JP').format(num)
    ),
  },
}
